import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnProjectList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const ProjectList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [projectList, setProjectList] = useState([]);
  const [projectListCount, setProjectListCount] = useState(0);
  const [projectListPerPage, setProjectListPerPage] = useState(10);
  const [activeProjectListPage, setActiveProjectListPage] = useState(1);
  const [searchProjectListFilter, setSearchProjectListFilter] = useState("");
  const [columnProjectListSorter, setColumnProjectListSorter] = useState({ column: "createdAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchProjectListFilter,
      limit: projectListPerPage,
      offset: projectListPerPage * activeProjectListPage - projectListPerPage,
      sort:
        (columnProjectListSorter &&
          `${columnProjectListSorter.column}%${columnProjectListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllProjects(queries);
  }, [
    searchProjectListFilter,
    projectListPerPage,
    activeProjectListPage,
    columnProjectListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveProjectListPage(1)
    setSearchProjectListFilter(search);
  }

  const fetchAllProjects = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/project?${queries}`
    })
      .then(({ data }) => {
        const tempProjectList = data?.value?.map((d) => ({
          ...d,
          client_name: d?.client?.name
        }));
        setProjectList(tempProjectList);
        if (activeProjectListPage === 1) {
          setProjectListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/project/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          showSuccess('Project has been successfully deleted')
          fetchAllProjects()
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/project/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.name}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/project/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Project
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Project List</h4>}
        bodyContent={
          <AppTable
            projectListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnProjectList}
            tableContent={projectList}
            contentPerPage={projectListPerPage}
            activeContentPage={activeProjectListPage}
            contentCount={projectListCount}
            searchContentFilter={searchProjectListFilter}
            setActiveContentPage={setActiveProjectListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setProjectListPerPage}
            setColumnContentSorter={setColumnProjectListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default ProjectList